"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    RecurringBookingRequest: 'RecurringBookingRequest',
    BookingRequest: 'BookingRequest',
    BookingRescheduled: 'BookingRescheduled',
    BookRequestToTutor: 'BookRequestToTutor',
    TutorConfirmToStudent: 'TutorConfirmToStudent',
    TutorDeclineToStudent: 'TutorDeclineToStudent',
    DeleteConfirmedBooking: 'DeleteConfirmedBooking',
    NotifyCaseManagerFeedbackLowRating: 'NotifyCaseManagerFeedbackLowRating',
    NotifyCaseManagerFeedbackIncorrectDetail: 'NotifyCaseManagerFeedbackIncorrectDetail',
    SendContractInvitation: 'SendContractInvitation',
    SendUserInvitation: 'SendUserInvitation',
    NotifyCaseManagerTutorDecisionAccept: 'NotifyCaseManagerTutorDecisionAccept',
    NotifyCaseManagerTutorDecisionDecline: 'NotifyCaseManagerTutorDecisionDecline',
    NotifyTutorContractRemoved: 'NotifyTutorContractRemoved',
    NotifySubjectDetailsChanged: 'NotifySubjectDetailsChanged',
    NotifySubjectDetailsChangedToTutor: 'NotifySubjectDetailsChangedToTutor',
    NotifyAdminUserRegistered: 'NotifyAdminUserRegistered',
    NotifyUpdateBooking: 'NotifyUpdateBooking',
    AdminBookOnBehalf: 'AdminBookOnBehalf',
    AdminBookRecurringOnBehalf: 'AdminBookRecurringOnBehalf',
    AdminRescheduleOnBehalf: 'AdminRescheduleOnBehalf',
    AdminUpdateOnBehalf: 'AdminUpdateOnBehalf',
    AdminCancelForStudents: 'AdminCancelForStudents',
    AdminCancelForConfirmedTutors: 'AdminCancelForConfirmedTutors',
    NotifyCaseManagerTimeDisputeNotification: 'NotifyCaseManagerTimeDisputeNotification',
    NotifyStudentTutorAcceptedInvitation: 'NotifyStudentTutorAcceptedInvitation',
    LessonDetailSharedFile: 'LessonDetailSharedFile',
    LessonDetailCommented: 'LessonDetailCommented',
    LessonDetailReply: 'LessonDetailReply',
    LessonDetailAdminDeleteComment: 'LessonDetailAdminDeleteComment',
    LessonDetailAdminDeleteFile: 'LessonDetailAdminDeleteFile',
    NotifyStudentPackageHoursChanged: 'NotifyStudentPackageHoursChanged',
    NotifyStudentPackageStartChanged: 'NotifyStudentPackageStartChanged',
    NotifyTutorWhenSubjectAdded: 'NotifyTutorWhenSubjectAdded',
    NotifySuggestNewBookingTime: 'NotifySuggestNewBookingTime',
    NotifyNewMessages: 'NotifyNewMessages',
    NotifyTutorFacedRoadBlock: 'NotifyTutorFacedRoadBlock',
    NotifyTutorOfFullCapacity: 'NotifyTutorOfFullCapacity',
    NotifyTutorOfPendingAllocation: 'NotifyTutorOfPendingAllocation',
    NotifyCaseManagerOfPenaltySession: 'notifyCaseManagerOfPenaltySession',
};
//# sourceMappingURL=notification.js.map